export const getIsPosting = state => state.getIn(['casesContract', 'isPosting']);
export const getIsGeting = state => state.getIn(['casesContract', 'isGetting']);
export const getErrMsg = state => state.getIn(['casesContract', 'errMsg']);

export const getAppointorType = state => state.getIn(['casesContract', 'appointorType']);
export const getTypeId = state => state.getIn(['casesContract', 'typeId']);
export const getLawer = state => state.getIn(['casesContract', 'lawer']);
export const getAppointor = state => state.getIn(['casesContract', 'appointor']);
export const getCompany = state => state.getIn(['casesContract', 'company']);